import AuthPage from '../../pages/auth/AuthPage'

export default [
  {
    path: '/login',
    component: AuthPage,
    isAuthenticated: false
  }
]
